import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home/home.component';
import { AuthGuard } from './auth/auth.guard';
import { LoginComponent } from './auth/login/login.component';
import { IsAdminGuard } from './auth/is-admin.guard';
import { LandingComponent } from './landing/landing/landing.component';
import { ErrorComponent } from './error/error.component';
import { RequestResetComponent } from './auth/request-reset/request-reset.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { FeaturesComponent } from './landing/features/features.component';
import { PricingComponent } from './landing/pricing/pricing.component';
import { ContactComponent } from './landing/contact/contact.component';
import { SignupComponent } from './landing/signup/signup.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { TermsComponent } from './terms/terms.component';
import { AwaitingVerificationComponent } from './awaiting-verification/awaiting-verification.component';

const routes: Routes = [
    {
        path: 'home',
        component: HomeComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'decks',
        loadChildren: () => import('./decks/decks.module').then(mod => mod.DecksModule)
    },
    {
        path: 'admin',
        loadChildren: () => import('./admin/admin.module').then(mod => mod.AdminModule),
        canActivate: [AuthGuard, IsAdminGuard]
    },
    {
        path: 'inventory',
        loadChildren: () => import('./inventory/inventory.module').then(mod => mod.InventoryModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'users',
        loadChildren: () => import('./users/users.module').then(mod => mod.UsersModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'features',
        component: FeaturesComponent
    },
    {
        path: 'pricing',
        component: PricingComponent
    },
    {
        path: 'contact',
        component: ContactComponent
    },
    {
        path: 'signup',
        component: SignupComponent
    },
    {
        path: 'request-reset',
        component: RequestResetComponent
    },
    {
        path: 'reset-password',
        component: ResetPasswordComponent
    },
    {
        path: 'privacy',
        component: PrivacyComponent
    },
    {
        path: 'terms',
        component: TermsComponent
    },
    {
        path: 'error',
        component: ErrorComponent
    },
    {
        path: 'verify',
        component: AwaitingVerificationComponent,
    },
    {
        path: '',
        component: LandingComponent,
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
    exports: [RouterModule]
})
export class AppRoutingModule {}
